<template>
  <div>
    <ModalNotification
      v-model="modalWarning"
      :title="$t('global.alert.text.warning')"
      :msg="msg"
    >
      <template v-if="rejectedDos.length" #content-message>
        <p>{{ msg }}</p>
        <b-list-group>
          <b-list-group-item 
            v-for="(delivery, key) in selectedDos.filter(v => rejectedDos.includes(v.id))"
            :key="key"
          >
            <div class="d-flex justify-content-between">
              <div>{{ delivery.number }}</div>
              <div>
                <i class="mc-icon icon-fill_arrow-right me-1"/>
                <b-badge class="mc-badge-status">
                  {{ getStatus(delivery) }}
                </b-badge>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
        <p class="mt-2">{{ subMsg }}</p>
        <b-list-group>
          <b-list-group-item 
            v-for="(delivery, key) in selectedDos.filter(v => !rejectedDos.includes(v.id))"
            :key="key"
          >
            <div>{{ delivery.number }}</div>
          </b-list-group-item>
        </b-list-group>
      </template>
      <template #button-action>
        <template v-if="!areAllCustomersSame || selectedDos.length === rejectedDos.length">
          <McButton
            @click="modalWarning = false"
            variant="primary" 
            class="me-2"
            :text="$t('global.alert.text.understand')"
          />
        </template>
        <template v-else>
          <McButton
            @click="modalWarning = false"
            variant="secondary" 
            class="me-2"
            :text="$t('global.cancel')"
          />
          <McButton
            @click="$emit('handleContinue')"
            variant="primary" 
            class="me-2"
            :text="$t('global.action.continue')"
          />
        </template>
      </template>
    </ModalNotification>
  </div>
</template>

<script>
import ModalNotification from './ModalNotification'
import McButton from '@/components/McButton'
export default {
  components: { 
    ModalNotification,
    McButton
  },
  props: {
    value: {
      type: Boolean,
      require: true
    },
    msg: {
      type: String,
      require: true
    },
    subMsg: {
      type: String,
      default: ''
    },
    rejectedDos: {
      type: Array,
      default: () => ([])
    },
    selectedDos: {
      type: Array,
      default: () => ([])
    },
    areAllCustomersSame: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    modalWarning: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('update:value', newVal)
      }
    }
  },
  methods: {
    getStatus(delivery) {
      return ['Draf', 'Dibatalkan'].includes(delivery.status.name) ? `Status ${delivery.status.name}` : this.$t('delivery.invoice.warningMessage.alreadyBilled')
    }
  }
}
</script>